import React from 'react';
import { FormikState } from 'formik';
import { PriceSelectionFormFields } from 'subdomains/cpo/screens/GroupsAndPolicies/Tariff/PriceSelectionFormFields';
import { Restrictions } from 'subdomains/cpo/screens/GroupsAndPolicies/Tariff/Restrictions/Restrictions';
import { TariffComponent as TariffComponentType } from 'subdomains/cpo/types/charging-policy';
import { SetFieldValueFn } from 'subdomains/cpo/types/form';

type Props = {
  values: FormikState<TariffComponentType>['values'];
  setFieldValue: SetFieldValueFn;
  basePath?: string;
};

export const TariffComponentFormFields: React.FC<Props> = ({ values }) => {
  return (
    <>
      <PriceSelectionFormFields values={values?.price} />
      {values?.restrictions?.enabled && (
        <Restrictions values={values?.restrictions} basePath="restrictions" />
      )}
    </>
  );
};
